<link rel="stylesheet"
    href="https://demos.creative-tim.com/notus-js/assets/vendor/@fortawesome/fontawesome-free/css/all.min.css">

<div class="scroll" [ngClass]="{'show-scrollTop': windowScrolled}">
    <button class="border-none text-headerfr" (click)="scrollToTop()">
        <i class="fas fa-chevron-up"></i>
    </button>
</div>